module.exports = __webpack_public_path__ + "img/emoji_83.1400d0df.png";